import { useContext } from 'react';

import { AuthContext } from '@components/Providers/AuthProvider';

export const useAuth = () => {
  return useContext(AuthContext);
};
